/** biome-ignore-all lint/style/useNamingConvention: suppress lint key format in object */
import { validate } from './validators';

Object.defineProperty(window, '__env__', {
  configurable: false,
  value: window.__env__,
  writable: false,
});

Object.preventExtensions(window.__env__);

const _ENV_VARS = {
  REACT_APP_API_URL: import.meta.env.REACT_APP_API_URL,

  REACT_APP_BLOB_FILE_URL: import.meta.env.REACT_APP_BLOB_FILE_URL,
  REACT_APP_LOG_OBSOLETE_ENDPOINTS: import.meta.env.REACT_APP_LOG_OBSOLETE_ENDPOINTS,
  REACT_APP_MASTER_DATA_API_URL: import.meta.env.REACT_APP_MASTER_DATA_API_URL,
  REACT_APP_NEW_DOMAIN_URL: import.meta.env.REACT_APP_NEW_DOMAIN_URL,

  // If the environment variable is not defined,
  // the value will not be changed and
  // the process or import.meta.env will be undefined
  // REACT_APP_OIDC_AUTHORITY is optional for env
  REACT_APP_OIDC_AUTHORITY: import.meta.env.REACT_APP_OIDC_AUTHORITY,
  REACT_APP_OIDC_CLIENT_ID: import.meta.env.REACT_APP_OIDC_CLIENT_ID,
  REACT_APP_OIDC_SCOPES: import.meta.env.REACT_APP_OIDC_SCOPES,
  REACT_APP_ORIGIN_API: import.meta.env.REACT_APP_ORIGIN_API,
  REACT_APP_PRICING_API_URL: import.meta.env.REACT_APP_PRICING_API_URL,
  REACT_APP_RATE_UPS_AUTH: import.meta.env.REACT_APP_RATE_UPS_AUTH,
  // REACT_APP_API_RATESHOP_API: import.meta.env.REACT_APP_API_RATESHOP_API,
  // REACT_APP_API_RATESHOP_API_USER_NAME: import.meta.env.REACT_APP_API_RATESHOP_API_USER_NAME,
  // REACT_APP_API_RATESHOP_API_USER_PASSWORD: import.meta.env.REACT_APP_API_RATESHOP_API_USER_PASSWORD,

  REACT_APP_THEME: import.meta.env.REACT_APP_THEME,

  REACT_APP_TRIMPLE_MAPS_API_KEY: import.meta.env.REACT_APP_TRIMPLE_MAPS_API_KEY,
  VERSION: import.meta.env.VERSION,
  ...window.__env__,
};

console.log(`[VERSION]: ${_ENV_VARS.VERSION}`);

if (process.env.NODE_ENV === 'development') {
  console.log(_ENV_VARS);
}

export const ENV_VARS = validate(_ENV_VARS);
